/* ============================================================
   KKUMI — KKRail
   The ONE swipe indicator for a horizontal scroll rail. Mark the
   scrolling element with [data-kk-rail] and this appends a
   .kk-rail-hint after it (visuals live in assets/kkumi-tokens.css):
   a proportional progress bar whose thumb width is the share of the
   rail currently on screen and whose position tracks scrollLeft,
   plus a "swipe" label that fades out once the reader has swiped.

   The hint is built in JS and hidden whenever the rail is not
   actually overflowing — a rail that fits on screen (desktop, a
   short block list) must not advertise a gesture that does nothing,
   and with JS off the rail still scrolls natively with no dead
   control left behind.

   Optional: [data-kk-rail-label] overrides the label copy.
   ============================================================ */
(function () {
  'use strict';

  var ARROW =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M5 12h14"></path><path d="m13 6 6 6-6 6"></path></svg>';

  function build(rail) {
    var hint = document.createElement('div');
    hint.className = 'kk-rail-hint';
    // Decorative: the bar restates the scroll position a screen reader already
    // gets from the rail itself, and the label names a gesture it can't make.
    hint.setAttribute('aria-hidden', 'true');
    hint.hidden = true;

    var track = document.createElement('span');
    track.className = 'kk-rail-hint__track';
    var thumb = document.createElement('span');
    thumb.className = 'kk-rail-hint__thumb';
    track.appendChild(thumb);

    var label = document.createElement('span');
    label.className = 'kk-rail-hint__label';
    label.textContent = rail.getAttribute('data-kk-rail-label') || 'swipe';
    label.insertAdjacentHTML('beforeend', ARROW);

    hint.appendChild(track);
    hint.appendChild(label);
    rail.insertAdjacentElement('afterend', hint);
    return { hint: hint, thumb: thumb };
  }

  function measure(rail, ui) {
    var max = rail.scrollWidth - rail.clientWidth;
    // 4px of slack: sub-pixel layout rounding leaves a phantom pixel or two of
    // scrollWidth on rails that actually fit.
    if (max <= 4) { ui.hint.hidden = true; return; }
    ui.hint.hidden = false;

    var frac = rail.clientWidth / rail.scrollWidth;
    ui.thumb.style.width = frac * 100 + '%';
    // Thumb travel is (track - thumb); expressed as a % of the thumb's own
    // width — which is what translateX(%) resolves against — that is
    // (1 - frac) / frac.
    var progress = rail.scrollLeft / max;
    ui.thumb.style.transform = 'translateX(' + progress * ((1 - frac) / frac) * 100 + '%)';

    if (rail.scrollLeft > 8) ui.hint.classList.add('has-scrolled');
  }

  function mount(rail) {
    if (rail.dataset.kkRailBound) return;
    rail.dataset.kkRailBound = '1';

    var ui = build(rail);
    var queued = false;
    function update() {
      queued = false;
      measure(rail, ui);
    }
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }

    rail.addEventListener('scroll', schedule, { passive: true });
    if (window.ResizeObserver) {
      // Catches the breakpoint flip (the rail is a plain grid on desktop) and
      // late-loading images changing the scroll width, which resize misses.
      var ro = new ResizeObserver(schedule);
      ro.observe(rail);
      if (rail.firstElementChild) ro.observe(rail.firstElementChild);
    } else {
      window.addEventListener('resize', schedule);
    }
    window.addEventListener('load', schedule);
    update();
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-kk-rail]').forEach(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.KKRail = { mount: mount, boot: boot };
})();
